import { setTokenGetter, setUnauthorizedHandler } from './client';

// Configure the API client with auth token getter and optional 401 handler
export function configureApi(
  getToken: () => string | null,
  onUnauthorized?: () => void
) {
  setTokenGetter(getToken);
  setUnauthorizedHandler(onUnauthorized ?? null);
}
